import React from "react";
import ApprovalWorkflowView from "./ApprovalWorkflowView";

export default function ApprovalReviewView(props) {
  return <ApprovalWorkflowView {...props} mode="approve" />;
}
